export default "/fonts/icomoon.woff?f982fd140027fcc8b921572a1a1a9dba";